import React, { useState, useEffect, useRef } from 'react';
import Dropzone from 'react-dropzone';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { IconTrash } from '@wds/icons';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

const MAX_FILE_SIZE_IN_BYTES = 20 * 1024 * 1024; // 20 MB per file max

const DropZoneArea = (props) => {
	const [files, setFiles] = useState([]);
	const [error, setError] = useState(false);
	const refFiles = useRef(files);

	const handleOnDrop = (isError, droppedFiles) => {
		// NOTE: when isError is true, droppedFiles will be an array consisting of
		// the object { file: File, errors: FileError } } instead of just an array of File when isError is false.
		if (!isError) {
			setError(false);
			setFiles([...files, ...(droppedFiles.map((droppedFile) => {
				const uuid = uuidv4();
				return {
					fileInfo: droppedFile,
					uuid,
					onDelete: () => setFiles(refFiles.current.filter(file => file.uuid !== uuid)),
				};
			}))]);
		} else {
			setError(true);
		}
	};

	useEffect(() => {
		refFiles.current = files;
		props.onFileSuccess(files);
	}, [files]);

	return (
		<div>
			<Dropzone
				maxSize={MAX_FILE_SIZE_IN_BYTES}
				onDropAccepted={file => handleOnDrop(false, file)}
				onDropRejected={file => handleOnDrop(true, file)}
			>
				{({ getRootProps, getInputProps }) => (
					<div {...getRootProps({ className: 'sma-dropzone' })}>
						<input {...getInputProps()} />
						<p className="mb-0">
							{gettext('Click or drag and drop files to add')}
						</p>
					</div>
				)}
			</Dropzone>
			{error && (
				<Box my={1}>
					<Typography color="warning" component="p">
						{gettext('Your file was not uploaded. Please make sure files are smaller than 20 MB.')}
					</Typography>
				</Box>
			)}
			{files.map(file => (
				<div key={`${file.uuid}`} className="sma-support-form-file d-flex mt-2">
					<div className="sma-support-form-file-name p-2">
						{file.fileInfo.name}
					</div>
					<div
						className="my-auto"
						onClick={file.onDelete}
						onKeyPress={file.onDelete}
						role="button"
						tabIndex="0"
					>
						<IconTrash size="lg" />
					</div>
				</div>
			))}
		</div>
	);
};

DropZoneArea.propTypes = {
	onFileSuccess: PropTypes.func,
};

DropZoneArea.defaultProps = {
	onFileSuccess: () => null,
};

export default DropZoneArea;
